module.exports = __webpack_public_path__ + "static/bootstrap-badge-basic-f5d41af8fe782234942521eeb019b794.png";